export default __webpack_public_path__ + "static/media/RU.fa26ee92.svg";